import { render, staticRenderFns } from "./FlyAmericaStatusTag.vue?vue&type=template&id=e6238136&scoped=true&"
import script from "./FlyAmericaStatusTag.vue?vue&type=script&lang=js&"
export * from "./FlyAmericaStatusTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6238136",
  null
  
)

export default component.exports